import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BRAND, navItems } from '../data/content';
import { SocialLinks } from './SocialLinks';
import { CloseIcon, MenuIcon } from './icons/LineIcons';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${scrolled ? 'border-b border-white/5 bg-ink/85 backdrop-blur-xl' : 'border-b border-transparent bg-transparent'}`} data-id="element-144" data-mp="36d4mcs0kz2s9">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-6 px-5 sm:h-20 lg:px-10" data-id="element-145" data-mp="2wldxpru2t9bc">
        <a href="#inicio" className="flex items-center" aria-label={`${BRAND.name} — inicio`} data-id="element-146" data-mp="2rkq5x3y0wog2">
          <img src={BRAND.logoUrl} alt={BRAND.name} width={1536} height={1024} decoding="async" className="h-9 w-auto object-contain sm:h-11" data-id="element-147" data-mp="2mmx0id4jnygu" />
        </a>

        <nav aria-label="Navegación principal" className="hidden lg:block" data-id="element-148" data-mp="3acj0h2sqqhpw">
          <ul className="flex items-center gap-8" data-id="element-149" data-mp="3aelnddyljuqe">
            {navItems.map(item => <li key={item.href} data-id="element-150" data-mp="35jg28hd0qk3d">
                <a href={item.href} className="group relative font-sans text-[13px] font-medium uppercase tracking-[0.14em] text-white/75 transition-colors duration-300 hover:text-white" data-id="element-151" data-mp="30mzf9qhk2brv">
                  {item.label}
                  <span className="absolute -bottom-1.5 left-0 h-px w-0 bg-gold transition-all duration-300 group-hover:w-full" data-id="element-152" data-mp="3t9adiuhow0li" />
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="hidden items-center gap-5 lg:flex" data-id="element-153" data-mp="1hnrqlbna2ut5">
          <SocialLinks size="sm" data-id="element-154" data-mp="1hn8hmkflvgr9" />
          <a href="#reunion" className="rounded-md bg-gold px-5 py-2.5 font-sans text-[13px] font-semibold uppercase tracking-[0.1em] text-ink transition-all duration-300 hover:bg-goldsoft hover:shadow-[0_0_30px_-8px_rgba(245,197,24,0.9)] active:translate-y-px" data-id="element-155" data-mp="1mmuvmw39d114">
            Solicitar una reunión
          </a>
        </div>

        <button type="button" onClick={() => setOpen(true)} aria-label="Abrir menú" className="grid h-11 w-11 place-items-center rounded-md border border-steel/80 text-white transition-colors duration-300 hover:border-gold/60 hover:text-gold lg:hidden" data-id="element-156" data-mp="yqgt9wl7ibgc">
          <MenuIcon className="h-5 w-5" data-id="element-157" data-mp="2y18hxwid58f1" />
        </button>
      </div>
      <div className="hairline opacity-60" aria-hidden="true" data-id="element-158" data-mp="mfptg98azukk" />

      <AnimatePresence data-id="element-159" data-mp="hfle4mj4t5vx">
        {open ? <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="fixed inset-0 z-50 bg-ink/95 backdrop-blur-xl lg:hidden" role="dialog" aria-modal="true" aria-label="Menú" data-id="element-160" data-mp="hgwdma5jnrh8">
            <div className="flex h-16 items-center justify-between px-5 sm:h-20" data-id="element-161" data-mp="106310aha979d">
              <img src={BRAND.logoUrl} alt={BRAND.name} className="h-9 w-auto object-contain" data-id="element-162" data-mp="108fg8fvnp3iq" />
              <button type="button" onClick={() => setOpen(false)} aria-label="Cerrar menú" className="grid h-11 w-11 place-items-center rounded-md border border-steel/80 text-white transition-colors hover:border-gold/60 hover:text-gold" data-id="element-163" data-mp="1a5k5iokstf3r">
                <CloseIcon className="h-5 w-5" data-id="element-164" data-mp="22yfa1yl4hy57" />
              </button>
            </div>
            <nav aria-label="Navegación móvil" className="px-5 pt-6" data-id="element-165" data-mp="27wgvur9xobkd">
              <ul className="flex flex-col gap-1" data-id="element-166" data-mp="2cwlaebra6w7y">
                {navItems.map((item, index) => <motion.li key={item.href} initial={{
              opacity: 0,
              y: 12
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.05 * index,
              duration: 0.3
            }} className="border-b border-white/5" data-id="element-167" data-mp="2gyq41ahqbsul" data-mpi={index}>
                    <a href={item.href} onClick={() => setOpen(false)} className="block py-4 font-display text-2xl uppercase tracking-wide text-white transition-colors hover:text-gold" data-id="element-168" data-mp="1t82g5frf4sme">
                      {item.label}
                    </a>
                  </motion.li>)}
              </ul>
              <a href="#reunion" onClick={() => setOpen(false)} className="mt-8 block rounded-md bg-gold px-6 py-4 text-center font-sans text-sm font-semibold uppercase tracking-[0.1em] text-ink" data-id="element-169" data-mp="xyh1ykiyrdaz">
                Solicitar una reunión
              </a>
              <SocialLinks className="mt-8 justify-center" data-id="element-170" data-mp="jzhg1kmu5cii" />
            </nav>
          </motion.div> : null}
      </AnimatePresence>
    </header>;
}